import { gql } from "@apollo/client"

export const importBikes = gql`
mutation ImportBikes($bike: BikeInput!) {
  createBike (data: $bike) {
    data {id, attributes {name}}
  }
}`
